import React, { useEffect, useState } from "react";
import { MenuItem, IconButton, Menu, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import { updateActiveLanguage } from "../../redux/slices/Auth";
import { set } from "lockr";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const getFlagUrl = (iso: string) => {
  const languageToCountryMap: { [key: string]: string } = {
    en: "us",
    fr: "fr",
    es: "es",
    de: "de",
    yo: "ng",
    ig: "ng",
    ha: "ng",
    pi: "ng",
  };
  const countryIso =
    languageToCountryMap[iso.toLowerCase()] || iso.toLowerCase();
  return `https://flagcdn.com/48x36/${countryIso}.png`;
};

const LanguageSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const user = useSelector((state: RootState) => state.Auth.user);
  const { userLanguages, activeLanguage } = user;

  const dispatch = useDispatch();

  useEffect(() => {
    set("user", user);
  }, [user]);

  if (!userLanguages) return <></>;

  const switcherActiveLang = userLanguages.find(
    (lang) => lang.iso === activeLanguage
  );

  const handleSwitch = (value: string) => {
    dispatch(updateActiveLanguage(value));
    handleCloseMenu();
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        aria-controls={open ? "language-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onMouseEnter={handleOpenMenu}
        sx={{
          width: 42,
          height: 30,
          border: "1px solid rgba(131, 60, 65, 0.24)",
          borderRadius: "8px",
          color: "#7a6560",
          backgroundColor: "rgba(31, 22, 21, 0.72)",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "rgba(131, 60, 65, 0.16)",
            color: "#f9f3ef",
          },
        }}
      >
        <img
          src={getFlagUrl(switcherActiveLang?.iso || "us")}
          alt={switcherActiveLang?.name}
          style={{
            width: "20px",
            height: "15px",
            borderRadius: "2px",
            objectFit: "cover",
          }}
        />
        <ArrowDropDownIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          onMouseLeave: handleCloseMenu,
        }}
        PaperProps={{
          sx: {
            mt: 1,
            border: "1px solid rgba(131, 60, 65, 0.18)",
            borderRadius: "8px",
            backgroundColor: "#16100f",
            color: "#f0ece8",
            boxShadow: "0 18px 50px rgba(0, 0, 0, 0.34)",
          },
        }}
      >
        {userLanguages.map((lang) => (
          <MenuItem
            key={lang.iso}
            onClick={() => handleSwitch(lang.iso)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "13px",
              "&:hover": {
                backgroundColor: "rgba(131, 60, 65, 0.16)",
                color: "#fff",
              },
            }}
          >
            <img
              src={getFlagUrl(lang.iso)}
              alt={lang.name}
              style={{
                width: "22px",
                height: "16px",
                borderRadius: "2px",
                objectFit: "cover",
              }}
            />
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
